import { memo } from "react";
import ImportComponent from "./ImportComponent";
import {
  InternalNotesInput,
  NotesJsonArrInput,
  useMigrateClientNotesMutation,
  useNotesSampleCsvLazyQuery,
} from "src/generated/graphql";
import { IJsonArr, downloadCSV } from "src/utils/utils";
import { errorNotification } from "src/utils/alerts";
import { MESSAGES } from "src/utils/constants";
import { migrateErrors } from "./migrateMessage";

function NoteImports() {
  const [getSampleCsv, { loading: isCsvDownloading }] =
    useNotesSampleCsvLazyQuery();

  const [migrateNotes, { loading: uploadloading }] =
    useMigrateClientNotesMutation();

  const onUpload = async (jsonArr: IJsonArr) => {
    try {
      const notesJsonArrInput: NotesJsonArrInput = {
        data: jsonArr as InternalNotesInput[],
      };
      const { data } = await migrateNotes({
        variables: { data: notesJsonArrInput },
      });
      data && migrateErrors(data.migrateClientNotes.errors);
    } catch (err) {
      errorNotification({ message: MESSAGES.INVALID_CSV });
    }
  };

  const onDownload = async () => {
    const { data } = await getSampleCsv();
    downloadCSV(data?.notesSampleCSV, "Notes_Sample.csv");
  };
  return (
    <>
      <ImportComponent
        title="Step 2 - Notes Import"
        onDownload={onDownload}
        onUpload={onUpload}
        loading={isCsvDownloading}
        uploadloading={uploadloading}
      />
    </>
  );
}

export default memo(NoteImports);
